import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { AppBusinessStoreRedirectRoutes } from "./AppBusinessStoreRedirectRoutes";
import { AppBusinessStoreRedirectSite } from "./AppBusinessStoreRedirectSite";
import { AppBusinessStoreRedirectStore } from "./AppBusinessStoreRedirectStore";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class AppBusinessStoreRedirectContainer extends React.Component<IProps> {
    store: AppBusinessStoreRedirectStore;

    constructor(props: IProps) {
        super(props);
        this.store = new AppBusinessStoreRedirectStore();
    }

    async componentDidMount() {
        pushRoute(AppBusinessStoreRedirectRoutes.ROOT);
        try {
            georgeWebHeaderStore.configure({
                title: ui.__("appBusinessStoreRedirect.document.title"),
            });
        } catch (error) {
            debug.log("### AppBusinessStoreRedirectContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("appBusinessStoreRedirect.document.title");
        return (
            <div>
                <Route exact path={AppBusinessStoreRedirectRoutes.ROOT} component={this.withStore(AppBusinessStoreRedirectSite)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/appBusinessStoreRedirect/AppBusinessStoreRedirectContainer.tsx